import { useEffect, useRef } from 'react';
import { createLevelMonitor } from '@/shared/audio/recordingLevel';

export function useRecordingLevel() {
  const heardMsRef = useRef(0);
  const levelReadyRef = useRef(false);
  const countWhileRecordingRef = useRef(() => false);
  const levelMonitorRef = useRef(null);
  const mountedRef = useRef(true);

  function stopLevelMonitor() {
    levelMonitorRef.current?.stop();
    levelMonitorRef.current = null;
    levelReadyRef.current = false;
  }

  function startLevelMonitor(stream) {
    if (!mountedRef.current) return;
    stopLevelMonitor();
    heardMsRef.current = 0;
    if (!stream) return;
    try {
      const monitor = createLevelMonitor(stream, {
        shouldCount: () => countWhileRecordingRef.current(),
        onHeard: (ms) => {
          heardMsRef.current = ms;
        },
        onUnavailable: () => {
          if (levelMonitorRef.current === monitor) levelReadyRef.current = false;
        },
      });
      levelMonitorRef.current = monitor;
      monitor.ready.then((ok) => {
        if (levelMonitorRef.current === monitor) levelReadyRef.current = ok;
      });
    } catch (err) {
      console.warn('Level monitor unavailable:', err);
      levelReadyRef.current = false;
    }
  }

  useEffect(() => () => {
    mountedRef.current = false;
    levelMonitorRef.current?.stop();
    levelMonitorRef.current = null;
  }, []);

  function syncRecordingLevel(recordPluginInstance) {
    countWhileRecordingRef.current = () => {
      if (!recordPluginInstance) return false;
      try {
        return !recordPluginInstance.isPaused();
      } catch {
        return false;
      }
    };
  }

  return {
    heardMsRef,
    levelReadyRef,
    startLevelMonitor,
    stopLevelMonitor,
    syncRecordingLevel,
  };
}
